import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { roundUpCustom, validateArray } from "../../utils/validate";
import { FormDetailsDocument } from "./FormDetailsDocument";

const InputSubNotesValue = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });
  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="min-h-[360px]">
            <FormAddDocument
              data={document}
              item={item}
              reload={call}
              field={field}
              onClose={dialogClose}
              callDocument={callDocument}
              allData={data}
            />
          </div>
        )}
      </>
    );
  }

  function handleFormItems(item) {
    openDialog(
      <>
        {loadDocument && (
          <div className="">
            <FormDetailsDocument
              // data={document}
              item={item}
              reload={call}
              // field={field}
              onClose={dialogClose}
              // callDocument={callDocument}
            />
          </div>
        )}
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }
  console.log("dataa", data);
  // SUMAR
  const total =
    data &&
    data.reduce((sum, item) => {
      return sum + (parseFloat(item.description) || 0);
    }, 0);

  // TIPO DE CAMBIO: Desde description2
  const tcItem =
    data && data.find((item) => item.label.toLowerCase() === "t/c");
  const tipoCambio = parseFloat(tcItem?.description2) || 6.96;

  const totalBs = roundUpCustom(total * tipoCambio);

  // PORCENTAJES Y CÁLCULOS DE IMPUESTOS
  const gaItem =
    data && data.find((item) => item.label.toLowerCase() === "porcentaje ga");
  const gaPercentage = parseFloat(gaItem?.description2) || 10;
  const gaAmount = roundUpCustom((totalBs * gaPercentage) / 100);

  const ivaItem =
    data && data.find((item) => item.label.toLowerCase() === "porcentaje iva");
  const ivaPercentage = parseFloat(ivaItem?.description2) || 14.94;
  const ivaAmount = roundUpCustom(((totalBs + gaAmount) * ivaPercentage) / 100);

  const iceItem =
    data && data.find((item) => item.label.toLowerCase() === "porcentaje ice");
  const icePercentage = parseFloat(iceItem?.description2) || 0;
  const iceAmount = roundUpCustom((totalBs * icePercentage) / 100);

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
            allData={data}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Campo",
              },
              {
                name: "description2",
                label: "Porcentaje",
              },
              {
                name: "description",
                label: "Monto",
              },
              // {
              //   name: "observation",
              //   label: "Diferencia",
              // },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  // {
                  //   label: "Editar",
                  //   icon: "fas fa-table",
                  //   action: handleFormItems,
                  //   color: "text-[#1d4ed8]",
                  // },
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
          {data.length > 0 ? (
            <>
              <div className="divide-y pr-[25%] bg-gray-300">
                <div className="flex justify-between px-4 py-2">
                  <span>VALOR CIF ADUANA $us</span>
                  <span className="font-bold">$ {total.toFixed(2)} </span>
                </div>
                <div className="flex justify-between px-4 py-2">
                  <span>VALOR CIF ADUANA Bs.</span>
                  <span className="font-bold">Bs. {totalBs}</span>
                </div>
              </div>
              <div className="bg-gray-200 text-sm">
                {gaPercentage > 0 && (
                  <div className="flex justify-between px-4 py-2">
                    <span>GA ({gaPercentage}%)</span>
                    <span className="font-semibold">
                      Bs. {gaAmount.toFixed(2)}
                    </span>
                  </div>
                )}
                {ivaPercentage > 0 && (
                  <div className="flex justify-between px-4 py-2">
                    <span>IVA ({ivaPercentage}%)</span>
                    <span className="font-semibold">
                      Bs. {ivaAmount.toFixed(2)}
                    </span>
                  </div>
                )}
                {icePercentage > 0 && (
                  <div className="flex justify-between px-4 py-2 ">
                    <span>ICE ({icePercentage}%)</span>
                    <span className="font-semibold">
                      Bs. {iceAmount.toFixed(2)}
                    </span>
                  </div>
                )}
                {(gaPercentage > 0 ||
                  ivaPercentage > 0 ||
                  icePercentage > 0) && (
                  <div className="flex justify-between px-4 py-2">
                    <span>Formulario Digital Aduana</span>
                    <span className="font-semibold">Bs. 100</span>
                  </div>
                )}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const {
    data,
    item = null,
    reload,
    field,
    onClose,
    callDocument,
    allData,
  } = props;
  const [values, setValues] = useState({
    Label: item?.label ? item.label : validateArray(data) ? data[0].name : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
    Description2: item?.description2 ? item.description2 : "",
    isNew: false,
  });

  async function handleSubmit() {
    if (values.isNew) {
      await handleCreateOption(values);
    }
    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      item
        ? {
            ...values,
            // observation:
            //   parseFloat(values.Description2 ?? 0) -
            //   parseFloat(values.Description ?? 0),
          }
        : {
            ...values,
            // Description2: values.Description,
            // observation: 0,
          }
    )
      .then(() => {
        reload();
        onClose();
        setValues({
          ...values,
          NumberValue: 0,
          Description: "",
          Description2: "",
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  // Calcular porcentage del SEGURO con valor FOB
  const calculateSeguro = (percentage, allData) => {
    const fobItem = allData?.find((item) => item.label === "VALOR FOB");
    const valorFOB = parseFloat(fobItem?.description) || 0;
    return (valorFOB * parseFloat(percentage)) / 100;
  };

  function handleChangeInp(e) {
    const { name, value } = e.target;

    if (values.Label === "SEGURO" && name === "Description2") {
      const percentage = parseFloat(value) || 0;
      const seguroAmount = calculateSeguro(percentage, allData);

      setValues((a) => ({
        ...a,
        Description2: value,
        Description: seguroAmount.toFixed(2).toString(),
      }));
    } else {
      // Para otros casos, comportamiento normal
      setValues((a) => ({
        ...a,
        [name]: value,
      }));
    }
  }

  function handleChange(e) {
    let defaultDescription = "";
    let defaultDescription2 = "";

    // Lista de campos que van en description2
    const percentageFields = ["SEGURO", "T/C", "Porcentaje GA", "IVA", "ICE"];

    if (e.value === "SEGURO") {
      defaultDescription2 = "2";
    } else if (e.value === "T/C") {
      defaultDescription2 = "6.97";
    }

    let newDescription = "";
    if (e.value === "SEGURO") {
      const seguroAmount = calculateSeguro(defaultDescription2, allData);
      newDescription = seguroAmount.toFixed(2).toString();
    }

    setValues((a) => ({
      ...a,
      Label: e.value,
      Description:
        e.value === "SEGURO"
          ? newDescription
          : percentageFields.includes(e.value)
          ? ""
          : defaultDescription,
      Description2: percentageFields.includes(e.value)
        ? defaultDescription2
        : "",
      isNew: e.__isNew__ || false,
    }));
  }
  const percentageFields = [
    "SEGURO",
    "T/C",
    "Porcentaje GA",
    "Porcentaje IVA",
    "Porcentaje ICE",
  ];
  const shouldUseDescription2 = percentageFields.includes(values.Label);

  return (
    <form className="flex flex-col">
      <Label className={`mt-2`}>Lista de campos</Label>
      {validateArray(data) ? (
        <CreatableSelect
          isSearchable={true}
          onChange={handleChange}
          styles={{
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
          }}
          // defaultInputValue={values[field.name]}
          placeholder={"Seleccionar..."}
          isOptionSelected={false}
          // isLoading={field.urlApi ? !loading : false}
          options={data.map((option) => ({
            value: option.name,
            label: option.name,
          }))}
        />
      ) : null}

      {/* Label que cambia dinámicamente */}
      <Label className={`my-0 mt-4`}>
        {values.Label.toLowerCase().includes("porcentaje") ||
        values.Label.toLowerCase().includes("seguro") ||
        values.Label.toLowerCase().includes("%") ||
        values.Label.toLowerCase().includes("tasa") ||
        values.Label.toLowerCase().includes("rate")
          ? "Porcentaje"
          : item
          ? "Monto proforma"
          : "Monto"}
      </Label>

      {/* <Label className={`my-0 mt-4`}>{item ? "Monto proforma" : "Monto"}</Label> */}
      <div className={`flex gap-2 ${item ? "flex-col" : ""}`}>
        <input
          value={
            shouldUseDescription2 ? values.Description2 : values.Description
          }
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name={shouldUseDescription2 ? "Description2" : "Description"}
        />
        <span className="flex items-center px-2 text-gray-600">
          {[
            "SEGURO",
            "Porcentaje GA",
            "Porcentaje IVA",
            "Porcentaje ICE",
          ].includes(values.Label)
            ? "%"
            : ""}
        </span>
        {/* {item ? (
          <>
            <Label className={`my-0 mt-1`}>Monto planilla</Label>
            <input
              value={values.Description2}
              onChange={handleChangeInp}
              className="w-full p-2 rounded-md"
              type="text"
              name="Description2"
            />
          </>
        ) : null} */}
        <Button
          onClick={handleSubmit}
          className={`px-3 ${item ? "mt-2 py-3" : "py-0"}`}
        >
          Guardar
        </Button>
      </div>
    </form>
  );
};

export default InputSubNotesValue;
